export const SET_TITLE = 'SET_TITLE';

export const setTitle = ({ path, title }) => ({
  type: SET_TITLE,
  payload: {
    path,
    title,
  },
});
